import React, { useState, useEffect, useCallback } from 'react'
import './filter.css'
import { Modal, Button, Empty } from 'antd'
import { FiFilter, FiX, FiRotateCcw, FiCheck } from 'react-icons/fi'
import Thousand from './filters/Thousand'
import Thousandone from './filters/Thousandone'
import Thousandtwo from './filters/Thousandtwo'
import Thousandthree from './filters/Thousandthree'
import Thousandfour from './filters/Thousandfour'

export default function Filter(props) {
    const [filterData, setFilterData] = useState(null)
    const [filtername, setFiltername] = useState('')
    const [defaultValue, setDefaultValue] = useState([])
    const [updatedDefaultValue, setUpdatedDefaultValue] = useState([])
    const [unsetDefaultValue, setUnsetDefaultValue] = useState([])
    const [lastChange, setLastChange] = useState(undefined)

    // componentDidMount equivalent — builds the values/def/oldvalues map once from props.filters
    useEffect(() => {
console.log(props.filters,"props.filters")
        if (props.filters != undefined) {
            const obj = { values: {}, def: {}, oldvalues: {} }
            for (let i = 0; i < props.filters.length; i++) {
                obj.values[props.filters[i].filtername] = props.filters[i].values
                obj.def[props.filters[i].filtername] = props.filters[i].defval
                obj.oldvalues[props.filters[i].filtername] = props.filters[i].defval
            }
            setDefaultValue([obj])
            setUpdatedDefaultValue([obj])
            setUnsetDefaultValue([obj])
        }
        if (props.filters != null && props.filters.length > 0) {
            setFilterData(props.filters[0])
            setFiltername(props.filters[0].filtername)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const setFilter = useCallback((data) => {
        setFilterData(data)
        setFiltername(data.filtername)
    }, [])

    const updateDefaultvalues = useCallback((data) => {
        setUpdatedDefaultValue((prev) => {
            const clone = JSON.parse(JSON.stringify(prev))
            clone[0].def[filtername] = data
            return clone
        })
    }, [filtername])

    const updateDefaultCheckboxvalues = useCallback((data, lastchange) => {
        setLastChange(lastchange)
        setUpdatedDefaultValue((prev) => {
            const clone = JSON.parse(JSON.stringify(prev))
            clone[0].def[filtername] = data
            return clone
        })
    }, [filtername])

    const clearFilters = (e) => {
        e.preventDefault()
        props.clearFilters()
    }

    const applyFiltes = (e) => {
        e.preventDefault()
        if (updatedDefaultValue[0] && Object.keys(updatedDefaultValue[0].def).length !== 0) {
            setDefaultValue(updatedDefaultValue)
            const def = updatedDefaultValue[0].def
            const keys = Object.keys(def)
            let filterStr = ''
            for (let i = 0; i < keys.length; i++) {
                filterStr += def[keys[i]] + (i < keys.length - 1 ? '$#12$$' : '')
            }
            props.applyFiltes(filterStr, def)
        }
    }

    const goBack = (e) => {
        e.preventDefault()
        props.getCallback(true)
        setDefaultValue([])
    }

    const closeFilterModal = () => {
        // discard any edits that were never applied
        setUpdatedDefaultValue(defaultValue)
        props.onClose()
    }

    const renderFilterInput = () => {
        if (!filterData || !updatedDefaultValue[0]) {
            return <Empty description="No filters available" />
        }
        const def = updatedDefaultValue[0].def[filterData.filtername]
        const values = updatedDefaultValue[0].values[filterData.filtername]

        switch (filterData.filtertype) {
            case 1000:
                return <Thousand defdata={def} onChange={(val) => updateDefaultvalues(val)} />
            case 1001:
                return <Thousandone defdata={def} onChange={(val) => updateDefaultvalues(val)} />
            case 1002:
                return <Thousandtwo filterData={values} defdata={def} onChange={(val) => updateDefaultvalues(val)} />
            case 1003:
                return (
                    <Thousandthree
                        filterData={values}
                        defdata={def}
                        onChange={(val, lastchange) => updateDefaultCheckboxvalues(val, lastchange)}
                        lastChange={lastChange}
                    />
                )
            case 1004:
                return <Thousandfour filterData={values} defdata={def} onChange={(val) => updateDefaultvalues(val)} />
            default:
                return null
        }
    }

    return (
        <Modal
            open={props.isOpenModal}
            onCancel={closeFilterModal}
            footer={null}
            closable={false}
            width={720}
            centered
            className="filter-modal"
        >
            <div className="filter-modal__header">
                <div className="filter-modal__title">
                    <FiFilter size={18} />
                    <span>Filters</span>
                </div>
                <button className="filter-modal__close" onClick={closeFilterModal} aria-label="Close">
                    <FiX size={18} />
                </button>
            </div>

            <div className="filter-modal__body">
                <div className="filter-modal__sidebar">
                    {props.filters != null ? (
                        props.filters.map((data, index) => (
                            <div
                                key={index}
                                className={'filter-modal__sidebar-item' + (data.filtername === filtername ? ' active' : '')}
                                onClick={() => setFilter(data)}
                            >
                                {data.filtername}
                            </div>
                        ))
                    ) : (
                        <Empty description="No filters" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )}
                </div>

                <div className="filter-modal__content">{renderFilterInput()}</div>
            </div>

            <div className="filter-modal__footer">
                <Button icon={<FiRotateCcw size={14} />} onClick={clearFilters}>
                    Clear filters
                </Button>
                <Button type="primary" icon={<FiCheck size={14} />} onClick={applyFiltes}>
                    Apply filters
                </Button>
            </div>
        </Modal>
    )
}